/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FileSymlink = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7.5L14.5 2H6a2 2 0 0 0-2 2v7" }],
    ["polyline", { points: "14 2 14 8 20 8" }],
    ["path", { d: "m10 18 3-3-3-3" }],
    ["path", { d: "M4 18v-1a2 2 0 0 1 2-2h6" }]
  ]
];

export { FileSymlink as default };
//# sourceMappingURL=file-symlink.js.map
